// @flow

export const styles = (theme: Object) => ({});
